import type { CaseStudyContent } from './caseDetails';

export const equipmentGeoCase = {
  "eyebrow": "装备制造行业 GEO 案例",
  "summary": "一家面向政企客户的装备制造企业，希望将已有的行业积累延伸到 AI 采购研究。案例围绕供应商筛选、参数解释与交付条件组织信息；项目方反馈主流类目推荐位置靠前、表现稳定，具体监测范围仍待补充。",
  "keywords": [
    "装备制造GEO",
    "政企采购",
    "供应商选型",
    "技术参数",
    "AI推荐"
  ],
  "metrics": [
    {
      "value": "政企客户",
      "label": "服务对象",
      "note": "围绕采购前的信息研究"
    },
    {
      "value": "双渠道",
      "label": "采购渠道",
      "note": "招投标与电商采购"
    },
    {
      "value": "推荐首位",
      "label": "项目方效果反馈",
      "note": "主流类目；原始样本未披露"
    },
    {
      "value": "稳定表现",
      "label": "项目方观察",
      "note": "观察周期与复测频次待补充"
    }
  ],
  "overview": [
    {
      "label": "企业类型",
      "value": "装备制造企业，身份及设备细类已脱敏"
    },
    {
      "label": "市场基础",
      "value": "项目方描述其原有行业地位居前"
    },
    {
      "label": "采购路径",
      "value": "招投标与电商采购并行"
    },
    {
      "label": "优化目标",
      "value": "让行业实力在 AI 选型信息中得到准确呈现"
    }
  ],
  "channelsTitle": "采购场景：从了解供应商到理解技术条件",
  "channelsDescription": "内容围绕采购任务展开，支持资料调研与核验。",
  "channelHeaders": [
    "渠道",
    "决策任务",
    "内容重点"
  ],
  "channels": [
    {
      "channel": "招投标",
      "traffic": "采购前调研与能力核验",
      "challenge": "说明技术条件及适用工况，供采购方进一步评估。"
    },
    {
      "channel": "电商采购",
      "traffic": "配置选择与交付确认",
      "challenge": "解释类别、配置和服务范围，并连接官方资料。"
    }
  ],
  "painPointsTitle": "采购方关心的四类问题",
  "painPoints": [
    {
      "title": "类目与厂商",
      "description": "哪些供应商提供相应设备或方案？"
    },
    {
      "title": "能力与依据",
      "description": "企业的生产、交付及服务能力如何核实？"
    },
    {
      "title": "参数与工况",
      "description": "技术指标适用于哪些条件，彼此有何约束？"
    },
    {
      "title": "配置与履约",
      "description": "配置、报价、安装、维护与验收如何确认？"
    }
  ],
  "strategyDescription": "用可公开、可核实的事实解释能力，将产品、场景与服务边界联系起来。",
  "strategies": [
    {
      "step": "策略一",
      "title": "把行业能力整理为采购依据",
      "description": "围绕实际主营业务与技术积累组织资料。",
      "items": [
        "资质与客户信息仅在可公开范围使用",
        "用具体能力回答供应商核验问题"
      ]
    },
    {
      "step": "策略二",
      "title": "把技术指标放回使用场景",
      "description": "说明参数含义与适用条件，避免孤立比较。",
      "items": [
        "关联功能、配置与工况",
        "明确交付、调试、维护等服务边界"
      ]
    },
    {
      "step": "策略三",
      "title": "保持信源一致并持续复核",
      "description": "让官网、产品文档及采购页面能够相互印证。",
      "items": [
        "提供原始资料核验入口",
        "分别观察推荐位置、频次与准确性"
      ]
    }
  ],
  "resultsTitle": "项目表现：行业认知延伸到 AI 推荐",
  "resultHeaders": [
    "观察维度",
    "当前依据",
    "项目方反馈",
    "待核验内容"
  ],
  "results": [
    {
      "dimension": "主流类目",
      "before": "原文项目方描述",
      "after": "推荐首位",
      "change": "题库、回答样本及排序判定"
    },
    {
      "dimension": "平台覆盖",
      "before": "未附具体清单",
      "after": "覆盖多平台的类目推荐",
      "change": "平台、模型版本及查询条件"
    },
    {
      "dimension": "稳定性",
      "before": "未附连续监测记录",
      "after": "表现较稳定",
      "change": "周期、复测频次及波动"
    }
  ],
  "businessOutcomes": [
    "未提供询盘、入围、中标或订单的归因数据，不能由推荐位置推算业务增长。",
    "AI 信息用于辅助研究，正式评审和采购决定仍由采购方完成。"
  ],
  "takeaways": [
    "以实际业务和品牌积累为基础，用内容解释技术价值。",
    "公开资料相互印证，方便采购方回到原始信息核验。",
    "持续记录平台与问题变化，不用单次回答代表长期效果。"
  ],
  "disclaimer": "本页按公开案例整理，背景与效果均为项目方描述。原文尚未提供完整平台清单、题库、周期及原始监测样本，推荐首位不代表所有平台、问题和时点均排名第一。配图均为概念示意。",
  "images": {
    "hero": {
      "src": "/case-images/equipment-geo/00-hero.jpg",
      "alt": "装备制造能力与 AI 采购决策",
      "caption": "装备制造能力与 AI 采购决策。原案例概念配图，不代表真实设备、客户或采购项目。"
    },
    "overview": {
      "src": "/case-images/equipment-geo/01-context.jpg",
      "alt": "招投标与电商采购的信息研究",
      "caption": "招投标与电商采购的信息研究。原案例概念配图，不代表真实设备、客户或采购项目。"
    },
    "channels": {
      "src": "/case-images/equipment-geo/02-decisions.jpg",
      "alt": "供应商筛选与技术指标解读",
      "caption": "供应商筛选与技术指标解读。原案例概念配图，不代表真实设备、客户或采购项目。"
    },
    "strategy": {
      "src": "/case-images/equipment-geo/03-knowledge.jpg",
      "alt": "企业能力、产品参数与交付服务",
      "caption": "企业能力、产品参数与交付服务。原案例概念配图，不代表真实设备、客户或采购项目。"
    },
    "results": {
      "src": "/case-images/equipment-geo/04-results.jpg",
      "alt": "类目推荐与跨平台观察",
      "caption": "类目推荐与跨平台观察。原案例概念配图，不代表真实设备、客户或采购项目。"
    },
    "takeaways": {
      "src": "/case-images/equipment-geo/05-system.jpg",
      "alt": "业务、内容、信源与技术协同",
      "caption": "业务、内容、信源与技术协同。原案例概念配图，不代表真实设备、客户或采购项目。"
    }
  }
} satisfies CaseStudyContent;
